<template>
  <s-crud @returnObject='refresh($event)'
    no-border
    title="Zonas"
    :config="this.config"
    @save="saveDed($event)"
    add
    @clearForm="clearForm()"
    edit
    restore
    @rowSelected="rowSelected($event)" 
    remove
    :filter="filter"
   
  >
    <template scope="props">
      <v-container style="" v-if="props.item != null" class="pb-0">
        <v-row dense>
          <v-col lg="6" md="12" sm="12" cols="12" class="s-col-form">
            <s-text autofocus ref="ZonDescription" v-model="props.item.ZonDescription" label="Descripción " />
          </v-col>
          <v-col lg="3" md="6" sm="6" cols="6" class="s-col-form">
            <s-text autofocus ref="ZonDistance" v-model="props.item.ZonDistance" label="Distancia (KM)" />
          </v-col>
          <v-col lg="3" md="6" sm="6" cols="6" class="s-col-form">
            <s-select-definition v-model="props.item.ZonStatus" :def="1217" label="Estado"></s-select-definition>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="s-col-form">
            <s-text  ref="Latitude" v-model="props.item.Latitude" label="Latitud" />
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="s-col-form">
            <s-text  ref="Longitude" v-model="props.item.Longitude" label="Longitud" />
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:DedDescription="{ row }">
        <v-chip style="margin:0px" x-small :color="row.DedDescription == 'Inactivo' ? 'error' : 'success'">
            {{ row.DedDescription }}
        </v-chip>
      </template> 
  </s-crud>
</template>

<script>
import _sDefinitionDetail from "@/services/Technicalassistance/ZoneService.js";
export default {
  props: {
    //zonID: 0,
   
    //defDescription: "",
    ZonDescription:"",
  },
  data: () => ({
    dedValue:0,
      config: {
      title: "Definiciones Detalles",
      service: _sDefinitionDetail,
      model: {
        
        ZonID: "ID",
        ZonDescription: "string",
        ZonDistance: "int",
        SecStatus: "status",
        ZonStatus: "status",
        DedDescription:"String",
        Latitude: "decimal8",
        Longitude: "decimal8",
      },
      headers: [
          {
            //
          text: "ID",
          value: "ZonID",
          width: "5%",
          align: "end",
          sorteable: true,
        },
        {
          text: "Definicion",
          value: "ZonDescription",
          width: "35%",
          sorteable: true,
        },
        {
          text: "Distancia (KM)",
          value: "ZonDistance",
          width: "15%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Latitud",
          value: "Latitude",
          width: "15%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Longitud",
          value: "Longitude",
          width: "15%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Estado",
          value: "DedDescription",
          width: "15%",
          align: "center",
          sorteable: false,
        },
      ],
    },
  }),

  computed: {
   
    filter() {
      return {  };
    },
  },
  methods: {
 rowSelected(items) {
      if (items.length > 0) this.ZonaID = items[0].ZonID;
      console.log(items);
      this.$emit("rowSelected", items);
  },

    refresh(item){
      this.$emit('refresh',item);
    },
    clearForm() {
      this.$refs.ZonDescription.focus();
    },
    saveDed(item) {
      item.SecStatus=1;
       if (item.ZonDescription.length == 0) {
        this.$fun.alert("Registre descripción de valor", "warning");
        return;
      }
      item.save();       
    },
  },
};
</script>
